<div class="row-container">
  <fa-icon
    *ngIf="cell.icon"
    matTooltip="{{ 'SHARED_COMPONENTS.TABLE.ICON' | translate }}"
    matTooltipClass="prevent-selection"
    size="1x"
    [icon]="cell.icon"
    class="cursor-click"
  >
  </fa-icon>
  <mat-checkbox
    color="primary"
    matTooltip="{{ 'SHARED_COMPONENTS.TABLE.SELECT_CHECKBOX' | translate }}"
    disableRipple="true"
    [disabled]="!cell.isDisabled"
    [checked]="cell.isSelected"
    (change)="onCheckboxChange()"
    (click)="onCheckboxClick($event)"
  >
  </mat-checkbox>
  <div class="name-column highlight" matTooltip="{{ cell.value | displayTranslation }}">
    {{ cell.value | displayTranslation }}
  </div>
</div>
